import { useState, useEffect } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import useWindowSize from "../../../hooks/useWindow";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
// import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Icon } from "@iconify/react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import PageTitle from "../../../components/PageTitle";
// import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";

// const TERM_ENDPOINT = "/api/v1/school-plan/terms";

// const GET_SESSIONS = "/api/v1/school-plan/session";
const RECYCLE_BIN = "/api/v1/recycle-bin";

const index = () => {
  // const [allSessions, setAllSessions] = useState([]);
  // const [activeSession, setActiveSession] = useState([]);
  // const [aselectedTerm, setASelectedTerm] = useState("");
  // const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [gettingTrash, setGettingTrash] = useState(false);
  const [allTrash, setAllTrash] = useState([]);
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [searchResult, setSearchResult] = useState([]);
  const [restoreModal, setRestoreModal] = useState(false);
  const [currentSelected, setCurrentSelected] = useState({});
  const [isRestoring, setIsRestoring] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  /**
 * Closes the convert confirmation modal
 */
  const handleCloseRestoreModal = () => {
    setCurrentSelected({});
    setRestoreModal(false);
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  /**
 * Closes the delete confirmation modal
 */
  const handleCloseDeleteModal = () => {
    setCurrentSelected({});
    setDeleteModal(false);
  };

  /**
 * Opens convert confirmation modal for an exam
 * @param {Object} row - The exam row data to potentially convert
 */
  const handleRestoreAModal = (row) => {
    setCurrentSelected(row);
    setRestoreModal(!restoreModal);
  };

  /**
 * Opens convert confirmation modal for an exam
 * @param {Object} row - The exam row data to potentially convert
 */
  const handleDeleteModal = (row) => {
    setCurrentSelected(row);
    setDeleteModal(!deleteModal);
  };

  /**
   * Current window width and mobile status
   * @type {number} width - Current window width in pixels
   * @type {boolean} mobile - Whether window is mobile size (<600px)
   */
  const width = useWindowSize();
  const mobile = width < 600;
  /**
     * Retrieves all academic terms and filters them based on the selected session ID.
     *
     * @param {string} Session_ID - The ID of the selected academic session.
     */
  // const getAllTerms = (Session_ID) => {
  //   httprequest
  //     .get(TERM_ENDPOINT)
  //     .then((res) => {
  //       setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
  //     });
  //   // .catch(() => {});
  // };

  /**
 * Fetches attendance records for a specific class and term.
 *
 * @param {string} classId - The ID of the selected class.
 * @param {string} termId - The ID of the selected term.
 */
  const getDeletedTrash = () => {
    setGettingTrash(true);

    // Build query params
    let url = `${RECYCLE_BIN}`;

    if (dateRange.from) {
      url += `?from=${dateRange.from}`;
    }
    if (dateRange.to) {
      url += `&to=${dateRange.to}`;
    }

    httprequest
      .get(url)
      .then((res) => {
        setGettingTrash(false);
        setAllTrash(res?.data?.data?.items);
        setSearchResult(res?.data?.data?.items);
      })
      .catch((err) => {
        setGettingTrash(false);
        toast.error(err?.response?.data);
      });
  };

  /**
 * Handles conversion of an exam
 */
  const handleRestore = () => {
    setIsRestoring(true);
    httprequest.post(`${RECYCLE_BIN}/${currentSelected?.id}/restore`).then((res) => {
      setIsRestoring(false);
      toast.success(res?.data?.message);
      getDeletedTrash();
      handleCloseRestoreModal();
    }).catch((err) => {
      setIsRestoring(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Handles deletion of an exam
 */
  const handleDeletePermanently = () => {
    setIsDeleting(true);
    httprequest.delete(`${RECYCLE_BIN}/${currentSelected?.id}`).then(() => {
      setIsDeleting(false);
      toast.success("Deleted Permanently Succesfully");
      handleCloseDeleteModal();
      getDeletedTrash();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
   * Columns configuration for the exams table
   * @type {Array<Object>}
   * @property {string} name - Column header name
   * @property {function} selector - Function to render cell content
   * @property {boolean} [center] - Whether to center-align content
   * @property {boolean} [sortable] - Whether column is sortable
   * @property {function} [cell] - Custom cell renderer function
   */
  const columns = [
    {
      name: "Type",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Type</p>}
          {row?.type || "--/--"}
        </>
      )
    },
    {
      name: "Module",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Module</p>}
          {row?.module || "--/--"}
        </>
      )
    },
    {
      name: "Deleted By",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Deleted By</p>}
          {`${row?.deleted_by?.first_name || "-/-"} ${row?.deleted_by?.last_name || "-/-"}` || "--/--"}
        </>
      )
    },
    {
      name: "Email",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Email</p>}
          {row?.deleted_by?.email || "--/--"}
        </>
      )
    },
    {
      name: "Date Deleted",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date Deleted</p>}
          {row?.date_deleted.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row, index) => (
        <div key={index} className="table-action-container">
          <button
            className="table-action-icon"
            onClick={() => handleRestoreAModal(row)}
          >
            <Icon icon="ix:restore-backup" width="20" height="20" />
          </button>
          <button onClick={() => handleDeleteModal(row)} className="table-action-icon delete-icon">
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Handles session dropdown change and fetches terms for the selected session.
 *
 * @param {Event} e - The event triggered by the session selection.
 */
  // const handleSessionChange = (e) => {
  //   const Session_ID = e.target.value;
  //   // setASelectedSession(e.target.value);
  //   getAllTerms(Session_ID);
  // };

  /**
 * Handles term dropdown change and fetches attendance data for the selected term.
 *
 * @param {Event} event - The event triggered by the term selection.
 */
  // const handleTermChange = (event) => {
  //   const selectedTermId = event.target.value;
  //   setASelectedTerm(selectedTermId);
  //   getDeletedTrash(selectedTermId);
  // };

  /**
   * Fetches all academic sessions and sets the currently active session.
   */
  // const getAllSessions = async () => {
  //   try {
  //     const res = await httprequest.get(GET_SESSIONS);
  //     setAllSessions(res?.data?.data);
  //     setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
  //   } catch (err) {
  //     toast.error(err?.response?.message);
  //   }
  // };
  /**
     * Find Active Term in an Current Session
     */
  // const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  //   /**
  //  * Searches all enrolment exams by various fields
  //  * @param {Event} e - The search input event
  //  */
  const handleSearchTrash = (e) => {
    const { value } = e.target;
    const valArray = value.split(" ");

    // Filter by partial match in subject, class, and creator's name
    const result = allTrash?.filter((data) => valArray?.every(
      (word) => data?.type?.toLowerCase().includes(word.toLowerCase()) ||
                  data?.deleted_by?.first_name?.toLowerCase().includes(word.toLowerCase()) ||
                  data?.deleted_by?.email?.toLowerCase().includes(word.toLowerCase())
    ));

    setSearchResult(result || []);
  };

  /**
   * On component mount: fetches all classes, sessions, and terms.
   */
  useEffect(() => {
    getDeletedTrash();
  }, []);

  /**
   * Sets the selected term to the current active term whenever it changes.
   */
  // useEffect(() => {
  //   if (active_term_session?.id) {
  //     setASelectedTerm(active_term_session.id);
  //     getDeletedTrash(active_term_session.id);
  //   }
  // }, [active_term_session]);

  /**
   * Fetches terms whenever the active session is updated.
   */
  // useEffect(() => {
  //   if (activeSession?.id) {
  //     getAllTerms(activeSession?.id);
  //   }
  // }, [activeSession]);

  return (
    <>
      <PageTitle
        title="Trash"
        subtitle="View all deleted data and restore them if you want"
      />
      <div className="">
        <Table data={searchResult} columns={columns} subHeader={true} pagination subHeaderComponent={
          <div className="action_div">
            <TableSearch placeholder="Search here..." searchTableFunc={handleSearchTrash} />
            <div className="text-center gap-10 cursor-pointer">
              {gettingTrash ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                : <Icon onClick={() => getDeletedTrash()} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
              <div className="flex gap-10 align-items-end margin-top-5">
                {/* <div>
                  {activeSession?.id && (
                    <SelectGroup
                      children={
                        <select
                          defaultValue={activeSession?.id}
                          onChange={handleSessionChange}
                          name="session"
                        >
                          <option value="">---Select---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div>
                <div>
                  {active_term_session?.id && (
                    <SelectGroup
                      children={
                        <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                          <option value="">---Select---</option>
                          {selectedSessionTerms?.map((data) => {
                            return (
                              <option key={data?.id} value={data?.id}>
                                {data?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div> */}
                <>
                  <InputGroup
                    label="From"
                    margin="normal"
                    placeHolder="Select Date"
                    inputType="date"
                    inputName="from"
                    onChange={handleDateChange}
                  />
                </>
                <>
                  <InputGroup
                    label="To"
                    margin="normal"
                    placeHolder="Select Date"
                    inputType="date"
                    inputName="to"
                    onChange={handleDateChange}
                  />
                </>
                <>
                  <Button
                    variant="primaryoutline"
                    color="btnfontprimary"
                    buttonSize="medium"
                    buttonName="Apply Filters"
                    isLoading={gettingTrash}
                    onClick={getDeletedTrash}
                  />
                </>
              </div>
            </div>
          </div>}
        />
        {/* <ToastContainer /> */}
        {/* Convert MOdal */}
        <Modal
          title="Restore Deleted Trash"
          subtitle={
            <div>
            Are you sure you want to restore
              {" "}{currentSelected?.type}?
            </div>
          }
          modalContent={<></>}
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonName="Restore"
                buttonSize="full"
                color="btndefault"
                onClick={handleRestore}
                isLoading={isRestoring}
              />
            </>
          }
          isopen={restoreModal}
          closeModal={handleCloseRestoreModal}
        />

        <Modal
          title="Are you sure you want to delete this, this will be a permamnent approach?"
          subtitle={
            <div>
            Are you sure you want to Delete
              {" "}{currentSelected?.type}?
            </div>}
          modalContent={
            <>

            </>
          }
          modalFooter={
            <>
              <Button variant="danger" buttonName="Delete Permanently" buttonSize="full" color="btndefault" onClick={handleDeletePermanently} isLoading={isDeleting} />
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
      </div>
    </>
  );
};

export default index;
